export const CHANGE_ENABLED_BUTTON = 'CHANGE_ENABLED_BUTTON';
export const CHANGE_BOTTOM_BUTTON_PAYLOAD = 'CHANGE_BOTTOM_BUTTON_PAYLOAD';
